import { useUser } from '../contexts/UserContext'
import { permissionType } from '../utils/constants'

export const useSubscriptionPermissions = () => {
  const { canAccess, user } = useUser()
  const arePermissionsLoaded = Boolean(user)

  const canViewSubscriptions = canAccess(permissionType.TAB_SUBSCRIPTIONS, 0)

  return {
    arePermissionsLoaded,
    canViewSubscriptions
  }
}
